import { DEFAULT_REVIEWS_TOTAL_THRESHOLD, RECOMMENDED_RATING_THRESHOLD } from 'constants/review'
import { isOrderPast } from 'lib/order/isUpcoming'

export function checkOrderAcceptsReview(order?: App.Order) {
  if (!order) return false

  const isTravelledOrder = isOrderPast(order)
  const isValidOrderType = !!(order.items.length || order.tourItems.length || order.experienceItems.length || order.bedbankItems.length)
  const isCompletedItem = isOrderItemCompleted(order)

  return isTravelledOrder && isValidOrderType && isCompletedItem
}

/**
 * For now we're only getting the first item inside order to leave reviews
 * So we get only 1 review by order. For this reason, we check status of the first item
 */
export function isOrderItemCompleted(order: App.Order): boolean {
  return !!order.items.length && order.items[0].status === 'completed' ||
    !!order.bedbankItems.length && order.bedbankItems[0].status === 'completed' ||
    !!order.tourItems.length && order.tourItems[0].status === 'completed' ||
    !!order.experienceItems.length && order.experienceItems[0].status === 'completed'
}

export function isOfferRatingDisplayable(
  rating: App.OfferRating | undefined,
  /**
   * Minimum number of reviews required on a rating to be displayed.
   */
  reviewsTotalThreshold: number = DEFAULT_REVIEWS_TOTAL_THRESHOLD,
): rating is App.OfferRating {
  if (!rating) return false
  return !!rating.score && rating.reviewsTotal >= reviewsTotalThreshold
}

export function isExperienceOfferRatingDisplayable(experienceOffer: App.ExperienceOffer | App.ExperienceBookingView): boolean {
  return !!experienceOffer.rating?.score && !experienceOffer.disableReviews
}

export const getRecommendsLabel = (review: App.Review) => {
  const label = review.rating >= RECOMMENDED_RATING_THRESHOLD ? 'Recommends' : 'Does not recommend'
  if (review.experienceId) return label + ' this experience'
  if (review.tourId) return label + ' this tour'

  return label + ' this hotel'
}
